export type CatalogMenuItem = {
  label: string;
  href: string;
  icon: string;
  sub: string[];
  is_featured?: boolean;
};

export const sharedCatalogMenu: CatalogMenuItem[] = [
  {
    label: 'PC Gaming',
    href: '/danh-muc/pc-gaming',
    icon: '🖥️',
    sub: ['PC Gaming', 'PC Đồ Hoạ', 'PC AI', 'Mini PC'],
  },
  {
    label: 'PC văn phòng',
    href: '/danh-muc/pc-van-phong',
    icon: '💼',
    sub: ['PC văn phòng', 'PC doanh nghiệp', 'Mini PC'],
  },
  {
    label: 'CPU, Mainboard, VGA',
    href: '/danh-muc/cpu-mainboard-vga',
    icon: '⚙️',
    sub: ['CPU Intel', 'CPU AMD', 'Mainboard Intel', 'Mainboard AMD', 'VGA NVIDIA', 'VGA AMD'],
  },
  {
    label: 'RAM, SSD, HDD',
    href: '/danh-muc/ram-ssd-hdd',
    icon: '💾',
    sub: ['RAM DDR4', 'RAM DDR5', 'SSD NVMe', 'SSD SATA', 'HDD'],
  },
  {
    label: 'Laptop',
    href: '/danh-muc/laptop',
    icon: '💻',
    sub: ['Laptop Gaming', 'Laptop Văn phòng', 'Laptop AI'],
  },
  {
    label: 'Màn hình',
    href: '/danh-muc/man-hinh',
    icon: '🖥️',
    sub: [],
  },
  {
    label: 'Case, Tản, Nguồn',
    href: '/danh-muc/case-tan-nguon',
    icon: '🔌',
    sub: ['Case Gaming', 'Case Văn phòng', 'Tản nhiệt', 'Nguồn máy tính'],
  },
  {
    label: 'Phím, chuột, tai nghe',
    href: '/danh-muc/phim-chuot-tai-nghe',
    icon: '🎮',
    sub: ['Bàn phím', 'Chuột', 'Tai nghe'],
  },
  {
    label: 'Bàn, ghế',
    href: '/danh-muc/ban-ghe',
    icon: '🪑',
    sub: ['Ghế Gaming', 'Ghế Công thái học', 'Bàn Gaming'],
  },
  {
    label: 'Thiết bị mạng',
    href: '/danh-muc/thiet-bi-mang',
    icon: '📡',
    sub: [],
  },
  {
    label: 'Máy in, UPS',
    href: '/danh-muc/may-in-ups',
    icon: '🖨️',
    sub: ['Máy in màu', 'Máy in đen trắng', 'UPS'],
  },
  {
    label: 'Camera, webcam',
    href: '/danh-muc/camera-webcam',
    icon: '📷',
    sub: ['Camera trong nhà', 'Camera ngoài trời', 'Webcam'],
  },
];
